import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Loader from 'components/_UI/Loader';
import ticketsApi from 'api/requests/tickets';
import { Column } from 'styled/alignment/Column';
import SalesPanel from '../../_sales/SalesPanel';

const COPY = {
    // A develop rotulava este card como "Ingressos vendidos" também aqui,
    // por cópia do arquivo de ingressos.
    soldLabel: 'Produtos vendidos',
    iconName: 'label',
    sectionTitle: 'Desempenho por produto',
    sectionSubtitle: 'Quanto cada produto vendeu, arrecadou e ainda tem em estoque.',
    sortLabel: 'Ordenar produtos',
    hiddenLabel: 'Produto oculto',
    emptyText: 'Nenhum produto cadastrado para este evento.',
};

export default function ProductDetail({ data }) {
    const [payload, setPayload] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getProducts(data);
    }, [data]);

    async function getProducts(slug) {
        setIsLoading(true);

        try {
            const { data: response } = await ticketsApi.getTicketForEvent(slug);
            setPayload(response);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    if (isLoading) {
        return (
            <ContentLoader>
                <Loader />
            </ContentLoader>
        );
    }

    const soldOnline = Number(payload?.products_sold) || 0;
    const soldOffline = Number(payload?.products_sold_offline) || 0;
    const revenueOnline = Number(payload?.products_revenue_sold) || 0;
    const revenueOffline = Number(payload?.products_revenue_offline) || 0;

    /* Mesma leitura da aba de ingressos: `products_sold` e
       `products_revenue_sold` já são o recorte online, e o presencial vem nos
       campos `*_offline`. Os cards do topo ficam com o online, que fecha com a
       lista de desempenho; o PDV aparece em bloco próprio. */
    return (
        <SalesPanel
            items={payload?.products || []}
            copy={COPY}
            eventSlug={data}
            totals={{
                sold: soldOnline,
                total: payload?.products_total,
                revenueSold: revenueOnline,
                revenuePotential: payload?.products_revenue_total,
            }}
            channels={{ soldOnline, soldOffline, revenueOnline, revenueOffline }}
        />
    );
}

const ContentLoader = styled(Column)`
    min-height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
